import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'convertDashCaseToTitle',
})
export class ConvertDashCaseToTitlePipe implements PipeTransform {
  transform(value: unknown, ...args: unknown[]): string | null {
    if (typeof value !== 'string') {
      return null;
    }
    return value.replace(/_/g, ' ');
  }
}
